import React from 'react';
import Dialog from 'src/components/common/Dialog';
import DialogList from 'src/dialogs';
import Button from 'src/components/controls/forms/redesign/FormButton';

interface IConfirmDeleteDocDialogProps {
    s3FileId?: number;
    confirmDelete: () => void;
    cancelDelete: () => void;
}

const ConfirmDeleteDocDialog = (props: IConfirmDeleteDocDialogProps) => {
    return (
        <Dialog title="Confirm Delete" dialogName={DialogList.DELETE_DOC}>
            <div style={{ textAlign: 'center', fontSize: '2rem' }} className="mb-2">
                Are you sure you want to delete this document?
            </div>
            <div style={{ textAlign: 'center' }}>
                <Button text="Delete" onClick={props.confirmDelete} className="mr-2" intent="danger" />
                <Button text="Cancel" onClick={props.cancelDelete} intent="primary" />
            </div>
        </Dialog>
    );
};

export default ConfirmDeleteDocDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/ConfirmDeleteDocDialog.tsx